import Floor from "../models/Floor";
import Page from "../models/Page";
import Point from "../models/Point";
import Room from "../models/Room";

export default class GuideUtils {
  static openRoom(): Room | undefined {
    const page = state.activePanes.items[state.activePanes.activeItemIndex.value]?.item;
    if (page?.className == "Page" && (page as Page).isRoomPlan) {
      return page.parent as Room;
    } else {
      return undefined;
    }
  }

  static openFloor(): Floor | undefined {
    const page = state.activePanes.items[state.activePanes.activeItemIndex.value]?.item;
    if (page?.className == "Page" && (page as Page).isFloorPlan) {
      return page.parent as Floor;
    }

    return undefined;
  }

  static openRoomDrawingAreaId(): Array<string> | undefined {
    const page = state.activePanes.items[state.activePanes.activeItemIndex.value]?.item;
    if (page?.className == "Page" && (page as Page).isRoomPlan) {
      return [page.id, "mainDrawingArea"]; // no itx
    } else {
      return undefined;
    }
  }
  static openFloorDrawingAreaId(): Array<string> | undefined {
    const page = state.activePanes.items[state.activePanes.activeItemIndex.value]?.item;
    if (page?.className == "Page" && (page as Page).isFloorPlan) {
      return [page.id, "mainDrawingArea"]; // no itx
    } else {
      return undefined;
    }
  }
}

export function runUiCloseAnimation() {
  const menuElement = document.getElementById("menu_guide");
  if (menuElement) {
    const r = menuElement.getBoundingClientRect();
    const p = new Point((r.left + r.right) / 2, (r.top + r.bottom) / 2);

    const elm = document.getElementById("guideUi_Inner");
    if (elm) {
      const saveTransition = elm.style.transition;
      elm.style.transition = "left 2s, top 2s"; // no itx

      elm.style.left = `${p.x}px`;
      elm.style.top = `${p.y}px`;
      const avatar = elm.querySelector(".avatar") as HTMLElement; // no itx
      if (avatar) {
        avatar.style.height = "35px"; // no itx
        avatar.style.width = "35px"; // no itx

        setTimeout(() => {
          avatar.style.opacity = "0";
          elm.style.transition = saveTransition;
        }, 2000);
      }
      const content = elm.querySelector(".content") as HTMLElement; // no itx
      if (content) {
        content.style.display = "none";
      }
    }

    setTimeout(() => {
      state.guideMode.isHidden = true;
      state.guideMode.currentStorylineIndex = 0;
    }, 3000);
  }
}

// /**
//  * Creates and mirrors a select input element; from the DOM
//  * @param           {string} id                                 Identifier of element within DOM
//  * @param           {string} id                                 Identifier of element within DOM
//  */
// function createSelectOptions(id = { origin: undefined, target: undefined, option: undefined }) {
//   /**
//    * Creates a ul element, mirroring the passed select input element
//    * @param           {Object} element                            Select element from DOM
//    * @param           {Object} tools                              #tools object from 'this' context; this.#tools
//    * @return          {Object}                                    Ul element with subsequent li elements
//    */
//   function _createUl(element, tools) {
//     let _checkMark =
//       '<img width="20" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjk3IDQuOTdhLjc1Ljc1IDAgMCAxIDEuMDcgMS4wNWwtMy45OSA0Ljk5YS43NS43NSAwIDAgMS0xLjA4LjAyTDQuMzI0IDguMzg0YS43NS43NSAwIDEgMSAxLjA2LTEuMDZsMi4wOTQgMi4wOTMgMy40NzMtNC40MjVhLjI2Ny4yNjcgMCAwIDEgLjAyLS4wMjJ6Ii8+Cjwvc3ZnPg=="/>';

//     let _ul = document.createElement("ul");

//     _ul.style.cssText = tools.jsonToCss(_css.ul);

//     for (let _i = 0; _i < element.length; _i++) {
//       let _text = element[_i].innerText;

//       let _icon = document.createElement("span");

//       _icon.style = tools.jsonToCss(_css.icon);

//       _icon.innerHTML = element[_i].attributes.selected != undefined ? _checkMark : " ";

//       let _span = document.createElement("span");

//       _span.innerText = _text;

//       let _li = document.createElement("li");

//       _li.style = tools.jsonToCss(_css.li);

//       _li.id = _option - 1 == _i ? id.target : "";

//       _li.setAttribute("onmouseover", "this.style.background = 'rgb(73,133,218)';");

//       _li.setAttribute("onmouseout", "this.style.background = 'none';");

//       _li.setAttribute(
//         "onclick",
//         `for ( let _child of this.parentElement.children ) _child.firstChild.firstChild.innerHTML = ' '; this.firstChild.firstChild.insertAdjacentHTML ( 'afterbegin', '${_checkMark}' ); for ( let _option of ${id.origin}.options ) if ( _option.attributes.selected != undefined ) _option.removeAttribute ( 'selected' ); else if ( _option.index == ${_option} - 1 ) _option.setAttribute ( 'selected', '' ); setTimeout ( ( ) => this.parentElement.style.display = 'none', 100 );`,
//       );

//       ////////////////////////////////////////////////////////////
//       _span.prepend(_icon);

//       _li.append(_span);

//       _ul.appendChild(_li);
//     }

//     return _ul;
//   }

//   ////    OPTION    //////////////////////////////////////////////////
//   let _option = id.option.match(/(\d+)(?!.*\d)/)[0];

//   ////    SELECT    //////////////////////////////////////////////////
//   let _select = window.getElementByXPathYYY(id.origin);

//   let _point = this.#tools.getCenterPoint(_select);

//   ////    CSS    /////////////////////////////////////////////////////
//   let _css = Guide_Cursor.config.presentation.settings.css.ui.select;

//   _css.ul.left = _point.x - _select.getBoundingClientRect().width / 2;

//   _css.ul.top = _point.y - _select.getBoundingClientRect().height / 2;

//   ////    UL CREATION    /////////////////////////////////////////////
//   document.body.appendChild(_createUl(_select, this.#tools));
// }
